import { type ComponentProps } from "react";
import MDEditor from "@uiw/react-md-editor";

import { cn } from "@/lib/utils";

type MDEditorProps = ComponentProps<typeof MDEditor>;

interface MarkdownEditorField {
  name?: string;
  onBlur?: MDEditorProps["onBlur"];
  onChange?: MDEditorProps["onChange"];
  value?: string | null;
}

interface MarkdownEditorProps {
  className?: string;
  field: MarkdownEditorField;
  textareaProps?: MDEditorProps["textareaProps"];
}

export const MarkdownEditor = ({ className, field, textareaProps }: MarkdownEditorProps) => (
  <div className={cn("[&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-6 [&_ol]:pl-6", className)}>
    <MDEditor
      {...field}
      value={field.value ?? ""}
      textareaProps={textareaProps}
      data-color-mode="light"
    />
  </div>
);
